import { useEffect, useRef } from 'react';
import Highcharts from 'highcharts';
import 'highcharts/modules/accessibility'

import moment from "moment";

const darkTheme = {
  chart: {
    backgroundColor: '#212529',
    style: {
      fontFamily: "'Roboto Condensed', sans-serif",
      fontSize: '16px',
      color: '#eeeeee'
    }
  },
  title: {
    style: {
      color: '#ffffff',
      opacity: 0.4
    }
  },
  xAxis: {
    gridLineColor: '#444444',
    labels: {
      style: {
        color: '#eeeeee'
      }
    },
    lineColor: '#777777',
    tickColor: '#777777',
    title: {
      style: {
        color: '#ffffff'
      }
    }
  },
  yAxis: {
    gridLineColor: '#444444',
    labels: {
      style: {
        color: '#dddddd'
      }
    },
    lineColor: '#777777',
    tickColor: '#777777',
    title: {
      style: {
        color: '#eeeeee'
      }
    }
  },
  legend: {
    enabled: true,
    itemStyle: {
      color: '#eeeeee'
    },
    itemHoverStyle: {
      color: '#aaaaaa'
    }
  },
  tooltip: {
    backgroundColor: '#333333',
    style: {
      color: '#ffffff'
    }
  },
  plotOptions: {
    series: {
      dataLabels: {
        color: '#ffffff'
      }
    }
  }
};

/* 
 * Los datos meteorologicos se introducen en series (variable serie)
 * para una o varias estaciones. Los datos se se prepocesan para 
 * reestructurarlos en utils.data2series donde también asignan algunos
 * atributos de formato (color, marker, etc.)
 */

Highcharts.setOptions(darkTheme);

const Chart = ({
  title = null,
  series = [], // Array de objetos: [{ name: 'Station 1', data: [...], color?: '#color' }]
  limits = { 'soft': null, 'hard': null },
  ylim = null,   // [min, max]
  xtickInterval = 2 * 60 * 60 * 1000, // Intervalo de 2 horas
  ytickInterval = 10,
  yAxisLabel = '',
  containerId = 'chart-container',
  height = '250',
  // Props para compatibilidad hacia atrás (serie única)
  seriesName = null,
  data = null,
}) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current) {

      Highcharts.chart(chartRef.current, {
        chart: {
          type: 'line',
          height: height,
        },
        title: {
          text: title,
        },
        tooltip: {
          useHTML: true,
          padding: 0,
          formatter: function() {
            return '<div style="padding: 3px; background-color: '+ this.series.color+' !important;" class="tooltip_header">'+ this.series.name  + ' ' + this.y + '</div>'+
                    '<div class="tooltip_container">' +
                    '  <div class="tooltip_body">' +
                    '     <b>UT:</b> ' + moment.utc(this.x).format("HH:mm") + 
                    '     - <b>Local time:</b> ' + moment.utc(this.x).tz('Atlantic/Canary').format("HH:mm")  +
                    '     <br><b>Date:</b> ' + moment.utc(this.x).tz('Atlantic/Canary').format("YYYY-MM-DD")  +
                    '  </div>' +
                    '</div>';
          }
        },
        xAxis: {
          type: 'datetime',
          tickInterval: xtickInterval,
          labels: {
            format: '{value:%H:%M}',
            color: '#dddddd'
          },
          title: {
            text: 'UT',
            style: {
              color: '#ffffff'
            }
          }
        },
        yAxis: {
          title: {
            text: yAxisLabel,
          },
          // Limites de seguridad
          plotLines: [
            {
              color: 'rgba(221, 208, 18, 0.5)',
              dashStyle: 'LongDashDot',
              width: 1,
              value: limits.soft
            },
            {
              color: 'rgba(255, 0, 0, 0.8)',
              dashStyle: 'Dot',
              width: 1,
              value: limits.hard
            },
          ].filter(line => line.value !== null), // Filtra líneas con valor null (eg. dust)
          min: ylim ? ylim[0] : null,
          max: ylim ? ylim[1] : null,
          tickInterval: ytickInterval
        },
        series: data,
        time: {
          useUTC: true,
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: data.length > 1, // Mostrar leyenda solo si hay múltiples series
        }
      });
    }
  }, [title, series, seriesName, data, yAxisLabel, limits, ylim, xtickInterval, ytickInterval, height]);

  return <div ref={chartRef} id={containerId} className='' />;
};

export default Chart;